import React, { useState, useEffect } from 'react'
import axiosInstance from '../../services/axiosInstance'
import PageHeader from '../../components/common/PageHeader'
import ChatPanel from '../../components/common/ChatPanel'
import { MessageSquare, AlertCircle } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import './styles.scss'

export default function StudentMessages() {
  const { user } = useAuth()
  const [appContext, setAppContext] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchData()
    markRead()
  }, [])

  const markRead = async () => {
    try {
      await axiosInstance.put('/api/messages/mark-read')
      // Let the global unread context know, if we add one later, or just fire and forget
    } catch (e) {
      console.error('Failed to mark messages as read', e)
    }
  }

  const fetchData = async () => {
    try {
      setLoading(true)
      const appRes = await axiosInstance.get('/api/applications/me')
      const app = appRes.data?.data
      setAppContext(app)
    } catch (e) {
      console.error('Failed to load application context', e)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="page-container">
        <PageHeader title="Messages" subtitle="Communicate with your admissions team" />
        <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}>
          <div className="spinner" style={{ width: '40px', height: '40px', border: '3px solid rgba(37,99,235,0.2)', borderTopColor: '#2563EB', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        </div>
      </div>
    )
  }

  if (!appContext) {
    return (
      <div className="page-container student-messages">
        <PageHeader title="Messages" />
        <div className="empty-state">
          <AlertCircle size={48} className="empty-icon" />
          <h3>No Application Found</h3>
          <p>You must start an application before you can message the admissions team.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="page-container student-messages">
      <PageHeader 
        title="Messages" 
        subtitle={`Chat directly with the admissions team at ${appContext.universityName}.`}
      />

      <div className="messages-layout">
        <div className="chat-container">
          <ChatPanel isAdmin={false} />
        </div>
        
        <div className="info-sidebar">
          <div className="info-card">
            <div className="icon-wrapper">
              <MessageSquare size={24} color="#1d4ed8" />
            </div>
            <h3>How it works</h3>
            <p>This is your direct line to the university admissions office. Use this chat to:</p>
            <ul>
              <li>Ask questions about required documents</li>
              <li>Get help with the I-20 or Visa process</li>
              <li>Request assistance with housing or airport pickup</li>
              <li>Check on your application status</li>
            </ul>
            <div className="response-time">
              <strong>Average Response Time:</strong> 24-48 hours
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
